import { useEffect } from 'react';

export interface UseLoadingSensorCleanupProps {
  data: Record<string, any>;
  isSectionLoading: (sectionId: string) => boolean;
  clearLoadingSensor?: (sensorName: string) => void;
  loadingSensors: Set<string> | null | undefined;
}

/**
 * Clears loading sensors when data finishes loading
 * Monitors each section's data and clears loading state for sensors that have loaded
 */
export function useLoadingSensorCleanup({
  data,
  isSectionLoading,
  clearLoadingSensor,
  loadingSensors,
}: UseLoadingSensorCleanupProps): void {
  useEffect(() => {
    if (!clearLoadingSensor || !loadingSensors) return;

    // Check each section's data
    Object.keys(data || {}).forEach((sectionId) => {
      const sectionData = data[sectionId];
      const isLoading = isSectionLoading(sectionId);

      // If section has data and is not loading, clear loading state for all sensors in that section
      if (sectionData && !isLoading) {
        // Get all sensor names from the section's data
        const sensorNames = Array.isArray(sectionData?.data)
          ? sectionData.data.map((sensor: any) => sensor.displayName || sensor.name)
          : Object.keys(sectionData?.data || {});

        // Clear loading state for sensors that are in the global loading set
        sensorNames.forEach((sensorName: string) => {
          if (loadingSensors.has(sensorName)) {
            clearLoadingSensor(sensorName);
          }
        });
      }
    });
  }, [data, isSectionLoading, clearLoadingSensor, loadingSensors]);
}
